import { createContext, useContext } from "react";

/**
 * Re-mounts the current page in place (same URL) — provided by ProtectedRoutes around <Outlet />.
 * Used after switching DISCO from the top bar so the page reloads with the new company.
 */
export const PageRemountContext = createContext(() => {});

export const usePageRemount = () => useContext(PageRemountContext);
